
// Soft UI Dashboard PRO React Base Styles
import colors from "./../../base/colors";
import typography from "./../../base/typography";
import borders from "./../../base/borders";

// Soft UI Dashboard PRO helper functions
import pxToRem from "./../../functions/pxToRem";

const { dark, white, grey, inputColors } = colors;
const { size, fontWeightRegular } = typography;
const { borderWidth, borderRadius } = borders;

export default {
    styleOverrides: {
        root: {
            marginTop:'0 !important'
        },

        standard: {

        },
        filled: {
            backgroundColor: 'white',
            borderRadius: '8px',
            padding: '6px',
            height: 'fit-content',
            minWidth:'40px',
            justifyContent:'center'
        }
    }
};